/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { StyledNotification } from './headerNotificationStyles';
export var EmbersHeaderNotification = function EmbersHeaderNotification(props) {
  var count = props.count,
    onClick = props.onClick;
  return /*#__PURE__*/React.createElement(StyledNotification, {
    className: "EmbersHeader-notification-root",
    onClick: !count || count === 0 ? void 0 : onClick
  }, !count || count === 0 ? null : /*#__PURE__*/React.createElement("span", {
    className: "icon-notification-fill"
  }), !count || count === 0 ? null : /*#__PURE__*/React.createElement("div", {
    className: "EmbersHeader-notification-count"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-number-".concat(count > 99 ? '99' : count, "-fill").concat(count > 99 ? '1' : '')
  })));
};